import * as constants from './constants'
import { deleteAsJson, fetchAsJson, postAsJson, putAsJson } from '@eig-builder/core-utils/helpers/fetch-helper'
import { getUrl, siteNames } from '@eig-builder/core-utils/helpers/url-helper'

// Actions
export const logout = () => {
  return fetchAsJson(getUrl(siteNames.API_CRM, '/v1.0/logout'), {
    key: constants.GET_LOGOUT,
    convertToCamelCase: true
  })
}

export const migrateDomain = (domainId, accountId, partnerId) => {
  return postAsJson(
    getUrl(siteNames.API_CRM, `/v1.0/domain/migrate/${domainId}`),
    {
      // empty
    },
    {
      key: constants.POST_DOMAIN_MIGRATE,
      extraArguments: {
        domainId
      }
    },
    {
      'X-CRM-AccountId': accountId,
      'X-CRM-PartnerId': partnerId
    }
  )
}

export const deleteDomain = (domainId, accountId, partnerId) => {
  return deleteAsJson(
    getUrl(siteNames.API_CRM, `/v1.0/domain/${domainId}`),
    {
      // empty
    },
    {
      key: constants.POST_DELETE_DOMAIN,
      extraArguments: {
        domainId
      }
    },
    {
      'X-CRM-AccountId': accountId,
      'X-CRM-PartnerId': partnerId
    }
  )
}

export const swapDomains = domainInfo => {
  return postAsJson(getUrl(siteNames.API_CRM, '/v1.0/domain/swap'), domainInfo, {
    key: constants.POST_DOMAIN_SWAP
  })
}

export const enableLocalDebug = () => {
  return fetchAsJson(getUrl(siteNames.API_CRM, '/v1.0/token/enable-debug'), {
    key: constants.ENABLE_LOCAL_DEBUG,
    convertToCamelCase: true
  })
}

export const getUsersForTheirRoles = () => {
  return fetchAsJson(getUrl(siteNames.API_CRM, '/v1.0/admin/users'), {
    key: constants.GET_USERS_FOR_THEIR_ROLES,
    convertToCamelCase: true
  })
}

export const addRoleToUser = data => {
  return postAsJson(getUrl(siteNames.API_CRM, '/v1.0/admin/role/add'), data, {
    key: constants.ADD_USER_ROLES,
    convertToCamelCase: true
  })
}

export const removeRoleFromUser = data => {
  return postAsJson(getUrl(siteNames.API_CRM, '/v1.0/admin/role/remove'), data, {
    key: constants.REMOVE_USER_ROLES,
    convertToCamelCase: true
  })
}

export const getPayPalTransactions = () => {
  return fetchAsJson(getUrl(siteNames.API_CRM, '/v1.0/paypal/ipn'), {
    key: constants.GET_PAYPAL_TRANSACTIONS,
    convertToCamelCase: true
  })
}

export const getPayPalTransactionsById = transactionId => {
  return postAsJson(getUrl(siteNames.API_CRM, '/v1.0/paypal/ipn/transactionid'), transactionId, {
    key: constants.GET_PAYPAL_TRANSACTIONS,
    convertToCamelCase: true
  })
}

export const getPayPalTransactionsByAccountId = accountId => {
  return postAsJson(getUrl(siteNames.API_CRM, '/v1.0/paypal/ipn/accountid'), accountId, {
    key: constants.GET_PAYPAL_TRANSACTIONS,
    convertToCamelCase: true
  })
}

export const getPayPalTransactionsByUberId = uberClientId => {
  return postAsJson(getUrl(siteNames.API_CRM, '/v1.0/paypal/ipn/uberclientid'), uberClientId, {
    key: constants.GET_PAYPAL_TRANSACTIONS,
    convertToCamelCase: true
  })
}

export const loadAccountsByType = (value, type, similarity) => {
  return postAsJson(
    getUrl(siteNames.API_CRM, `/v1.0/search/${type}`),
    {
      search_items: [value],
      similarity: similarity.toString()
    },
    {
      key: constants.GET_ACCOUNT_BY_TYPE,
      extraArguments: {
        value
      }
    }
  )
}

export const lookupAccountsByType = (value, type, lookupCount) => {
  return postAsJson(
    getUrl(siteNames.API_CRM, `/v1.0/search/${type}/lookup`),
    {
      search_items: [value]
    },
    {
      key: constants.GET_ACCOUNT_BY_TYPE,
      convertToCamelCase: true,
      extraArguments: {
        value,
        lookupCount
      }
    }
  )
}

export const loadAccountById = (partnerId, accountId) => {
  return fetchAsJson(getUrl(siteNames.API_CRM, '/v1.0/account/'), {
    key: constants.GET_ACCOUNT_BY_ID,
    convertToCamelCase: true,
    fetchOptions: {
      headers: {
        'X-CRM-AccountId': accountId,
        'X-CRM-PartnerId': partnerId
      }
    }
  })
}

export const changeAccountEmail = (partnerId, accountId, email) => {
  return putAsJson(
    getUrl(siteNames.API_CRM, '/v1.0/account/changeemail'),
    email,
    {
      key: constants.POST_CHANGE_EMAIL
    },
    {
      'X-CRM-AccountId': accountId,
      'X-CRM-PartnerId': partnerId
    }
  )
}

export const loadAccountOrderById = (id, accountId, partnerId) => {
  return fetchAsJson(getUrl(siteNames.API_CRM, `/v1.0/order/${id}`), {
    key: constants.GET_ACCOUNT_ORDER_BY_ID,
    convertToCamelCase: true,
    fetchOptions: {
      headers: {
        'X-CRM-AccountId': accountId,
        'X-CRM-PartnerId': partnerId
      }
    }
  })
}

export const cancelOrderById = (id, accountId, partnerId) => {
  return fetchAsJson(getUrl(siteNames.API_CRM, `/v1.0/order/${id}/cancel`), {
    key: constants.CANCEL_ORDER_BY_ID,
    convertToCamelCase: true,
    fetchOptions: {
      headers: {
        'X-CRM-AccountId': accountId,
        'X-CRM-PartnerId': partnerId
      }
    }
  })
}

export const approveOrderById = (id, accountId, partnerId) => {
  return fetchAsJson(getUrl(siteNames.API_CRM, `/v1.0/order/${id}/approve`), {
    key: constants.APPROVE_ORDER_BY_ID,
    convertToCamelCase: true,
    fetchOptions: {
      headers: {
        'X-CRM-AccountId': accountId,
        'X-CRM-PartnerId': partnerId
      }
    }
  })
}

export const synchronizeCards = (accountId, partnerId) => {
  return fetchAsJson(getUrl(siteNames.API_CRM, '/v1.0/billing/updateCards'), {
    key: constants.SYNCHRONIZE_CARDS,
    convertToCamelCase: true,
    fetchOptions: {
      headers: {
        'X-CRM-AccountId': accountId,
        'X-CRM-PartnerId': partnerId
      }
    }
  })
}

export const loadServicesByAccount = (accountId, partnerId) => {
  return fetchAsJson(getUrl(siteNames.API_CRM, '/v1.0/account/services'), {
    key: constants.GET_SERVICES_BY_ACCOUNT,
    convertToCamelCase: true,
    fetchOptions: {
      headers: {
        'X-CRM-AccountId': accountId,
        'X-CRM-PartnerId': partnerId
      }
    }
  })
}

export const getFreeDomainAvailable = (accountId, partnerId) => {
  return fetchAsJson(getUrl(siteNames.API_CRM, '/v1.0/domain/list-free-domain-credits'), {
    key: constants.GET_FREE_DOMAIN_AVAILABLE,
    convertToCamelCase: true,
    fetchOptions: {
      headers: {
        'X-CRM-AccountId': accountId,
        'X-CRM-PartnerId': partnerId
      }
    }
  })
}

export const getFreeEmailAvailable = (accountId, partnerId) => {
  return fetchAsJson(getUrl(siteNames.API_CRM, '/v1.0/email/free-email-available'), {
    key: constants.GET_FREE_EMAIL_AVAILABLE,
    convertToCamelCase: true,
    fetchOptions: {
      headers: {
        'X-CRM-AccountId': accountId,
        'X-CRM-PartnerId': partnerId
      }
    }
  })
}

export const loadOrdersByAccount = (accountId, partnerId) => {
  return fetchAsJson(getUrl(siteNames.API_CRM, '/v1.0/account/orders'), {
    key: constants.GET_ORDERS_BY_ACCOUNT,
    convertToCamelCase: true,
    fetchOptions: {
      headers: {
        'X-CRM-AccountId': accountId,
        'X-CRM-PartnerId': partnerId
      }
    }
  })
}

export const loadPendingOrdersByAccount = (accountId, partnerId, pageSize, pageIndex) => {
  return fetchAsJson(getUrl(siteNames.API_CRM, `/v1.0/account/orders/pending/${pageSize}/${pageIndex}`), {
    key: constants.GET_PENDING_ORDERS_BY_ACCOUNT,
    convertToCamelCase: true,
    fetchOptions: {
      headers: {
        'X-CRM-AccountId': accountId,
        'X-CRM-PartnerId': partnerId
      }
    }
  })
}

export const loadCancelledOrdersByAccount = (accountId, partnerId, pageSize, pageIndex) => {
  return fetchAsJson(getUrl(siteNames.API_CRM, `/v1.0/account/orders/cancelled/${pageSize}/${pageIndex}`), {
    key: constants.GET_CANCELLED_ORDERS_BY_ACCOUNT,
    convertToCamelCase: true,
    fetchOptions: {
      headers: {
        'X-CRM-AccountId': accountId,
        'X-CRM-PartnerId': partnerId
      }
    }
  })
}

export const loadCompletedOrdersByAccount = (accountId, partnerId, pageSize, pageIndex) => {
  return fetchAsJson(getUrl(siteNames.API_CRM, `/v1.0/account/orders/completed/${pageSize}/${pageIndex}`), {
    key: constants.GET_COMPLETED_ORDERS_BY_ACCOUNT,
    convertToCamelCase: true,
    fetchOptions: {
      headers: {
        'X-CRM-AccountId': accountId,
        'X-CRM-PartnerId': partnerId
      }
    }
  })
}

export const loadEmailsByAccount = (accountId, partnerId) => {
  return fetchAsJson(getUrl(siteNames.API_CRM, '/v1.0/account/emails'), {
    key: constants.GET_EMAILS_BY_ACCOUNT,
    convertToCamelCase: true,
    fetchOptions: {
      headers: {
        'X-CRM-AccountId': accountId,
        'X-CRM-PartnerId': partnerId
      }
    }
  })
}

export const cancelAccountById = (data, partnerId, accountId) => {
  return deleteAsJson(
    getUrl(siteNames.API_CRM, '/v1.0/account/delete'),
    data,
    {
      key: constants.CANCEL_ACCOUNT,
      returnType: 'text'
    },
    {
      'X-CRM-AccountId': accountId,
      'X-CRM-PartnerId': partnerId
    }
  )
}

export const restoreAccountById = (accountId, partnerId) => {
  return putAsJson(
    getUrl(siteNames.API_CRM, '/v1.0/account/restore'),
    {},
    {
      key: constants.RESTORE_ACCOUNT
    },
    {
      'X-CRM-AccountId': accountId,
      'X-CRM-PartnerId': partnerId
    }
  )
}

export const getPayPalNewTransactions = (id, type, partnerId) => {
  return postAsJson(
    getUrl(siteNames.API_CRM, '/v1.0/paypal/payments'),
    {
      id: id,
      type: type,
      partner_id: partnerId
    },
    {
      key: constants.GET_PAYPAL_NEW_TRANSACTIONS,
      convertToCamelCase: true
    }
  )
}

export const cancelServiceById = (id, accountId, partnerId, cancelAtEndOfTerm = false) => {
  return postAsJson(
    getUrl(siteNames.API_CRM, `/v1.0/services/${id}/cancel?cancelAtEndOfTerm=${cancelAtEndOfTerm}`),
    id,
    {
      key: constants.CANCEL_SERVICE
    },
    {
      'X-CRM-AccountId': accountId,
      'X-CRM-PartnerId': partnerId
    }
  )
}

export const cancelMultipleServicesById = (postObj, accountId, partnerId) => {
  return postAsJson(
    getUrl(siteNames.API_CRM, '/v1.0/services/cancel'),
    postObj,
    {
      key: constants.CANCEL_MULTIPLE_SERVICES,
      extraArguments: postObj.ids
    },
    {
      'X-CRM-AccountId': accountId,
      'X-CRM-PartnerId': partnerId
    }
  )
}

export const restoreServiceById = (id, accountId, partnerId) => {
  return postAsJson(
    getUrl(siteNames.API_CRM, `/v1.0/services/${id}/reactivate`),
    id,
    {
      key: constants.RESTORE_SERVICE
    },
    {
      'X-CRM-AccountId': accountId,
      'X-CRM-PartnerId': partnerId
    }
  )
}

export const fetchFollowUpsList = () => {
  return fetchAsJson(getUrl(siteNames.API_CRM, '/v1.0/order/followups'), {
    key: constants.GET_FOLLOW_UPS,
    convertToCamelCase: true
  })
}

export const uploadImageReleaseNote = fileString => {
  return postAsJson(
    getUrl(siteNames.API_CRM, '/v1.0/images/upload'),
    {
      file_string: fileString
    },
    {
      key: constants.POST_IMAGE,
      convertToCamelCase: true
    }
  )
}

export const transferDomainByName = (domainName, accountId, partnerId) => {
  return postAsJson(
    getUrl(siteNames.API_CRM, '/v1.0/domain/transfer'),
    {
      domain_name: domainName
    },
    {
      key: constants.TRANSFER_DOMAIN_BY_NAME,
      convertToCamelCase: true
    },
    {
      'X-CRM-AccountId': accountId,
      'X-CRM-PartnerId': partnerId
    }
  )
}

export const getDomainById = (id, partnerId, accountId) => {
  return fetchAsJson(getUrl(siteNames.API_CRM, `/v1.0/domain/${id}`), {
    key: constants.GET_DOMAIN_BY_ID,
    convertToCamelCase: true,
    fetchOptions: {
      headers: {
        'X-CRM-AccountId': accountId,
        'X-CRM-PartnerId': partnerId
      }
    }
  })
}

export const getDNSById = (domainId, partnerId, accountId) => {
  return fetchAsJson(getUrl(siteNames.API_CRM, `/v1.0/domain/dns/${domainId}`), {
    key: constants.GET_DNS_BY_ID,
    convertToCamelCase: true,
    fetchOptions: {
      headers: {
        'X-CRM-AccountId': accountId,
        'X-CRM-PartnerId': partnerId
      }
    }
  })
}

export const searchRenewalsReport = data => {
  return postAsJson(getUrl(siteNames.API_CRM, '/v1.0/renewals'), data, {
    key: constants.POST_RENEWAL_REPORT,
    convertToCamelCase: true
  })
}

export const addDNSRecord = (data, domainId, partnerId, accountId) => {
  return postAsJson(
    getUrl(siteNames.API_CRM, `/v1.0/domain/dns/${domainId}`),
    {
      ...data
    },
    {
      key: constants.MODIFY_DNS
    },
    {
      'X-CRM-AccountId': accountId,
      'X-CRM-PartnerId': partnerId
    }
  )
}

export const modifyDNSRecord = (data, domainId, partnerId, accountId) => {
  return putAsJson(
    getUrl(siteNames.API_CRM, `/v1.0/domain/dns/${domainId}`),
    {
      ...data,
      current_value: data.currentValue
    },
    {
      key: constants.MODIFY_DNS
    },
    {
      'X-CRM-AccountId': accountId,
      'X-CRM-PartnerId': partnerId
    }
  )
}

export const deleteDNSRecord = (data, partnerId, accountId, domainId) => {
  return deleteAsJson(
    getUrl(siteNames.API_CRM, `/v1.0/domain/dns/${domainId}`),
    data,
    {
      key: constants.MODIFY_DNS
    },
    {
      'X-CRM-AccountId': accountId,
      'X-CRM-PartnerId': partnerId
    }
  )
}

export const loadAgentEventsByAccount = (partnerId, accountId) => {
  return fetchAsJson(getUrl(siteNames.API_CRM, '/v1.0/eventlogs/customer/agents'), {
    key: constants.GET_AGENT_EVENTS_BY_ACCOUNT,
    convertToCamelCase: true,
    fetchOptions: {
      headers: {
        'X-CRM-AccountId': accountId,
        'X-CRM-PartnerId': partnerId
      }
    }
  })
}

export const loadPasswordResetEventsByAccount = (partnerId, accountId) => {
  return fetchAsJson(getUrl(siteNames.API_CRM, '/v1.0/eventlogs/customer/password-resets'), {
    key: constants.GET_PASSWORD_RESET_EVENTS_BY_ACCOUNT,
    convertToCamelCase: true,
    fetchOptions: {
      headers: {
        'X-CRM-AccountId': accountId,
        'X-CRM-PartnerId': partnerId
      }
    }
  })
}

export const loadLoginEventsByAccount = (partnerId, accountId) => {
  return fetchAsJson(getUrl(siteNames.API_CRM, '/v1.0/eventlogs/customer/logins'), {
    key: constants.GET_LOGIN_EVENTS_BY_ACCOUNT,
    convertToCamelCase: true,
    fetchOptions: {
      headers: {
        'X-CRM-AccountId': accountId,
        'X-CRM-PartnerId': partnerId
      }
    }
  })
}

export const loadUberSmithEventsByUberClientId = (partnerId, accountId, uberClientId) => {
  return fetchAsJson(getUrl(siteNames.API_CRM, `/v1.0/eventlogs/customer/${uberClientId}/ubersmith`), {
    key: constants.GET_UBERSMITH_EVENTS_BY_UBERCLIENTID,
    convertToCamelCase: true,
    fetchOptions: {
      headers: {
        'X-CRM-AccountId': accountId,
        'X-CRM-PartnerId': partnerId
      }
    }
  })
}

export const loadSdnEventsByAccount = (partnerId, accountId) => {
  return fetchAsJson(getUrl(siteNames.API_CRM, '/v1.0/eventlogs/customer/sdn'), {
    key: constants.GET_SDN_EVENTS_BY_ACCOUNT,
    convertToCamelCase: true,
    fetchOptions: {
      headers: {
        'X-CRM-AccountId': accountId,
        'X-CRM-PartnerId': partnerId
      }
    }
  })
}

export const fraudPreventionAllowMailPurchases = (partnerId, accountId) => {
  return postAsJson(
    getUrl(siteNames.API_CRM, '/v1.0/fraud_prevention/allow_mail_purchases'),
    {
      // empty
    },
    {
      key: constants.POST_ALLOW_MAIL_PURCHASES
    },
    {
      'X-CRM-AccountId': accountId,
      'X-CRM-PartnerId': partnerId
    }
  )
}

export const fraudPreventionAllowDomainPurchases = (partnerId, accountId) => {
  return postAsJson(
    getUrl(siteNames.API_CRM, '/v1.0/fraud_prevention/allow_domain_purchases'),
    {
      // empty
    },
    {
      key: constants.POST_ALLOW_DOMAIN_PURCHASES
    },
    {
      'X-CRM-AccountId': accountId,
      'X-CRM-PartnerId': partnerId
    }
  )
}

export const fraudPreventionAllowChangePaymentMethod = (partnerId, accountId) => {
  return postAsJson(
    getUrl(siteNames.API_CRM, '/v1.0/fraud_prevention/allow_change_paymentmethod'),
    {
      // empty
    },
    {
      key: constants.POST_ALLOW_CHANGE_PAYMENT_METHOD
    },
    {
      'X-CRM-AccountId': accountId,
      'X-CRM-PartnerId': partnerId
    }
  )
}

export const loadCommentsByAccount = (partnerId, accountId) => {
  return fetchAsJson(getUrl(siteNames.API_CRM, `/v1.0/comments/${accountId}/${partnerId}`), {
    key: constants.GET_COMMENTS_BY_ACCOUNT,
    convertToCamelCase: true,
    fetchOptions: {
      headers: {
        'X-CRM-AccountId': accountId,
        'X-CRM-PartnerId': partnerId
      }
    }
  })
}

// if the comment object contains an id update the comment in the database, else add a new comment.
export const updateComment = (comment, partnerId, accountId) => {
  return putAsJson(
    getUrl(siteNames.API_CRM, '/v1.0/comments/update'),
    {
      ...comment
    },
    {
      key: constants.PUT_UPDATE_COMMENT
    },
    {
      'X-CRM-AccountId': accountId,
      'X-CRM-PartnerId': partnerId
    }
  )
}

export const createExternalPlatformAccount = body => {
  return postAsJson(getUrl(siteNames.API_CRM, '/v1.0/external-platform/create'), body, {
    key: constants.CREATE_EXTERNAL_ACCOUNT,
    convertToCamelCase: true
  })
}

export const loadUbersmithComments = (partnerId, accountId, uberClientId) => {
  return fetchAsJson(getUrl(siteNames.API_CRM, `/v1.0/comments/ubersmith/${uberClientId}`), {
    key: constants.GET_UBERSMITH_COMMENTS_BY_UBERCLIENTID,
    convertToCamelCase: true,
    fetchOptions: {
      headers: {
        'X-CRM-AccountId': accountId,
        'X-CRM-PartnerId': partnerId
      }
    }
  })
}

export const filterComments = requestBody => {
  return postAsJson(getUrl(siteNames.API_CRM, '/v1.0/comments/filter'), requestBody, {
    key: constants.FILTER_COMMENTS,
    convertToCamelCase: true
  })
}

export const resetFilterCommentsResponse = () => ({
  type: constants.RESET_FILTER_COMMENTS_RESPONSE
})

export const getNameServersByDomainId = (domainId, partnerId, accountId) => {
  return fetchAsJson(getUrl(siteNames.API_CRM, `/v1.0/domain/ns/${domainId}`), {
    key: constants.GET_NAMESERVERS_BY_DOMAIN_ID,
    convertToCamelCase: true,
    fetchOptions: {
      headers: {
        'X-CRM-AccountId': accountId,
        'X-CRM-PartnerId': partnerId
      }
    }
  })
}

export const updateNameServers = (domainId, nameServers, accountId, partnerId) => {
  return putAsJson(
    getUrl(siteNames.API_CRM, `/v1.0/domain/ns/${domainId}`),
    nameServers,
    {
      key: constants.UPDATE_NAMESERVERS_FOR_DOMAIN,
      dontShowErrorsInNotificationBar: true
    },
    {
      'X-CRM-AccountId': accountId,
      'X-CRM-PartnerId': partnerId
    }
  )
}

export const getChangeTargets = (billingServiceId, uberClientId, accountId, partnerId) => {
  return fetchAsJson(getUrl(siteNames.API_CRM, `/v1.0/services/${billingServiceId}/${uberClientId}/change_targets`), {
    key: constants.GET_CHANGE_TARGETS,
    convertToCamelCase: true,
    fetchOptions: {
      headers: {
        'X-CRM-AccountId': accountId,
        'X-CRM-PartnerId': partnerId
      }
    }
  })
}

export const changeService = (service, accountId, partnerId) => {
  return postAsJson(
    getUrl(siteNames.API_CRM, '/v1.0/services/change'),
    service,
    {
      key: constants.CHANGE_SERVICE
    },
    {
      'X-CRM-AccountId': accountId,
      'X-CRM-PartnerId': partnerId
    }
  )
}

export const AddService = (service, accountId, partnerId) => {
  return postAsJson(
    getUrl(siteNames.API_CRM, '/v1.0/services/add'),
    service,
    {
      key: constants.ADD_SERVICE
    },
    {
      'X-CRM-AccountId': accountId,
      'X-CRM-PartnerId': partnerId
    }
  )
}

export const resetAddServiceResponse = () => ({
  type: constants.RESET_ADD_SERVICE_RESPONSE
})

export const getPartners = () => {
  return fetchAsJson(getUrl(siteNames.API_CRM, '/v1.0/partner-api/partners'), {
    key: constants.GET_PARTNERS,
    convertToCamelCase: true
  })
}

export const createNewAccountTestTool = body => {
  return postAsJson(getUrl(siteNames.API_CRM, '/v1.0/partner-api/account/create'), body, {
    key: constants.CREATE_NEW_ACCOUNT_TEST_TOOL
  })
}

export const getAccountTestTool = body => {
  return postAsJson(getUrl(siteNames.API_CRM, '/v1.0/partner-api/account'), body, {
    key: constants.GET_ACCOUNT_TEST_TOOL
  })
}

export const getSitesTestTool = (accountId, partnerId) => {
  return fetchAsJson(getUrl(siteNames.API_CRM, '/v1.0/partner-api/sites'), {
    key: constants.GET_SITES_TEST_TOOL,
    convertToCamelCase: true,
    fetchOptions: {
      headers: {
        'X-CRM-AccountId': accountId,
        'X-CRM-PartnerId': partnerId
      }
    }
  })
}

export const createNewSiteTestTool = (body, accountId, partnerId) => {
  return postAsJson(
    getUrl(siteNames.API_CRM, '/v1.0/partner-api/site'),
    body,
    {
      key: constants.CREATE_NEW_SITE_TEST_TOOL
    },
    {
      'X-CRM-AccountId': accountId,
      'X-CRM-PartnerId': partnerId
    }
  )
}

export const generateTokenTestTool = (siteId, accountId, partnerId, query, postObj) => {
  return postAsJson(
    getUrl(siteNames.API_CRM, `/v1.0/partner-api/token/${siteId}?${query}`),
    postObj,
    {
      key: constants.GENERATE_TOKEN_TEST_TOOL
    },
    {
      'X-CRM-AccountId': accountId,
      'X-CRM-PartnerId': partnerId
    }
  )
}

export const resetTestTool = () => ({
  type: constants.RESET_TEST_TOOL
})

export const resetTestToolError = () => ({
  type: constants.RESET_TEST_TOOL_ERROR
})

export const accountRelink = (data, accountId, partnerId) => {
  return postAsJson(
    getUrl(siteNames.API_CRM, '/v1.0/accountrelink/builder'),
    data,
    {
      key: constants.ACCOUNT_RELINK
    },
    {
      'X-CRM-AccountId': accountId,
      'X-CRM-PartnerId': partnerId
    }
  )
}

export const addCredits = (data, accountId, partnerId) => {
  return postAsJson(
    getUrl(siteNames.API_CRM, '/v1.0/billing/add_credit'),
    data,
    {
      key: constants.ADD_CREDITS
    },
    {
      'X-CRM-AccountId': accountId,
      'X-CRM-PartnerId': partnerId
    }
  )
}

export const getDomainRenewalLogs = (domainId, accountId, partnerId) => {
  return fetchAsJson(getUrl(siteNames.API_CRM, `/v1.0/domain/renewal-logs/${domainId}`), {
    key: constants.GET_DOMAIN_RENEWAL_LOGS,
    convertToCamelCase: true,
    fetchOptions: {
      headers: {
        'X-CRM-AccountId': accountId,
        'X-CRM-PartnerId': partnerId
      }
    }
  })
}

export const getGoodwillCreditsForAccount = (accountId, partnerId) => {
  return fetchAsJson(getUrl(siteNames.API_CRM, '/v1.0/account/credits'), {
    key: constants.GET_GOODWILL_CREDITS_FOR_ACCOUNT,
    fetchOptions: {
      headers: {
        'X-CRM-AccountId': accountId,
        'X-CRM-PartnerId': partnerId
      }
    }
  })
}

export const removeFreeDomainCredit = (domainId, accountId, partnerId) => {
  return deleteAsJson(
    getUrl(siteNames.API_CRM, `/v1.0/domain/delete-free-domain-credit/${domainId}`),
    {},
    {
      key: constants.REMOVE_FREE_DOMAIN_CREDIT
    },
    {
      'X-CRM-AccountId': accountId,
      'X-CRM-PartnerId': partnerId
    }
  )
}

export const getRegisteredDomains = (accountId, partnerId) => {
  return fetchAsJson(getUrl(siteNames.API_CRM, '/v1.0/domain/registered'), {
    key: constants.GET_REGISTERED_DOMAINS,
    fetchOptions: {
      headers: {
        'X-CRM-AccountId': accountId,
        'X-CRM-PartnerId': partnerId
      }
    }
  })
}

export const downgradeAccount = (data, accountId, partnerId) => {
  return postAsJson(
    getUrl(siteNames.API_CRM, '/v1.0/account/downgrade'),
    data,
    {
      key: constants.DOWNGRADE_ACCOUNT,
      returnType: 'text'
    },
    {
      'X-CRM-AccountId': accountId,
      'X-CRM-PartnerId': partnerId
    }
  )
}

export const resetCancelAccount = () => ({
  type: constants.CANCEL_ACCOUNT_RESET
})

export const suspendDomain = (domainId, reason, accountId, partnerId) => {
  return postAsJson(
    getUrl(siteNames.API_CRM, `/v1.0/domain/suspend/${domainId}`),
    reason,
    {
      key: constants.SUSPEND_DOMAIN
    },
    {
      'X-CRM-AccountId': accountId,
      'X-CRM-PartnerId': partnerId
    }
  )
}

export const unsuspendDomain = (domainId, accountId, partnerId) => {
  return postAsJson(
    getUrl(siteNames.API_CRM, `/v1.0/domain/unsuspend/${domainId}`),
    {},
    {
      key: constants.UNSUSPEND_DOMAIN
    },
    {
      'X-CRM-AccountId': accountId,
      'X-CRM-PartnerId': partnerId
    }
  )
}

export const enablePrivacyProtection = (domainId, accountId, partnerId) => {
  return postAsJson(
    getUrl(siteNames.API_CRM, `/v1.0/domain/${domainId}/privacy-protection/enable`),
    {},
    {
      key: constants.ENABLE_PRIVACY_PROTECTION
    },
    {
      'X-CRM-AccountId': accountId,
      'X-CRM-PartnerId': partnerId
    }
  )
}

export const disablePrivacyProtection = (domainId, accountId, partnerId) => {
  return postAsJson(
    getUrl(siteNames.API_CRM, `/v1.0/domain/${domainId}/privacy-protection/disable`),
    {},
    {
      key: constants.DISABLE_PRIVACY_PROTECTION
    },
    {
      'X-CRM-AccountId': accountId,
      'X-CRM-PartnerId': partnerId
    }
  )
}

export const enableTheftProtection = (domainId, accountId, partnerId) => {
  return postAsJson(
    getUrl(siteNames.API_CRM, `/v1.0/domain/${domainId}/theft-protection/enable`),
    {},
    {
      key: constants.ENABLE_THEFT_PROTECTION
    },
    {
      'X-CRM-AccountId': accountId,
      'X-CRM-PartnerId': partnerId
    }
  )
}

export const disableTheftProtection = (domainId, accountId, partnerId) => {
  return postAsJson(
    getUrl(siteNames.API_CRM, `/v1.0/domain/${domainId}/theft-protection/disable`),
    {},
    {
      key: constants.DISABLE_THEFT_PROTECTION
    },
    {
      'X-CRM-AccountId': accountId,
      'X-CRM-PartnerId': partnerId
    }
  )
}

export const getRefundableServices = (accountId, partnerId) => {
  return fetchAsJson(getUrl(siteNames.API_CRM, '/v1.0/services/refundable_services'), {
    key: constants.GET_REFUNDABLE_SERVICES,
    fetchOptions: {
      headers: {
        'X-CRM-AccountId': accountId,
        'X-CRM-PartnerId': partnerId
      }
    }
  })
}

export const postRefundServices = (ids, refundType, accountId, partnerId, skipDomainRegistrationFreePlanIds) => {
  return postAsJson(
    getUrl(siteNames.API_CRM, '/v1.0/services/refund'),
    {
      ids: ids,
      refund_type: parseInt(refundType),
      skip_initial_domain_registration_fee_plan_ids: skipDomainRegistrationFreePlanIds
    },
    {
      key: constants.POST_REFUND_SERVICES,
      returnType: 'text'
    },
    {
      'X-CRM-AccountId': accountId,
      'X-CRM-PartnerId': partnerId
    }
  )
}

export const getInteractionEvents = (accountId, partnerId) => {
  // TODO Update const's or make them variable
  const startDate = 'Thu Aug 1 2019' // hardcoded startDate (can be used later)
  const endDate = new Date().toISOString()
  return fetchAsJson(getUrl(siteNames.API_CRM, `/v1.0/customer-events?start=${startDate}&end=${endDate}`), {
    key: constants.GET_INTERACTION_EVENTS,
    fetchOptions: {
      headers: {
        'X-CRM-AccountId': accountId,
        'X-CRM-PartnerId': partnerId
      }
    }
  })
}
export const postSinglePlatformLocation = body => {
  return postAsJson(getUrl(siteNames.API_CRM, '/v1.0/singleplatform/keys'), body, {
    key: constants.POST_SINGLEPLATFORM_LOCATION
  })
}

export const resetSinglePlatformLocationResponse = () => ({
  type: constants.POST_SINGLEPLATFORM_LOCATION_RESET
})
